<div class="flex items-center justify-center px-4 py-8 lg:py-12">
  <div class="w-full max-w-lg p-10 rounded-2xl shadow-sm border border-gray-50 text-center space-y-8">

    <div class="space-y-3">
      <h1 class="text-3xl font-semibold text-[#0D3543]"> {{ 'auth.resetPassword.title' | translate }}</h1>
      <p class="text-gray-500 text-sm font-normal px-8">
        {{ 'auth.resetPassword.description' | translate }}
      </p>
    </div>

    <form class="space-y-6 text-left" (ngSubmit)="onReset()">

      @if (errorMessage) {
      <div class="p-3 rounded-lg bg-red-50 text-red-700 text-sm border border-red-200">
        {{ errorMessage }}
      </div>
      }

      <div>
        <label class="block text-[#0D3543] mb-2 text-sm font-medium"> {{ 'auth.common.password' | translate }}</label>
        <div class="relative flex items-center">
          <sham-i-lock-password-Bulk class="absolute start-3 text-[#6C737F] *:size-5" />
          <input type="password" [(ngModel)]="password" name="password" placeholder="****"
            class="w-full ps-10 pe-4 py-3 border border-[#BBDEEB] rounded-lg focus:ring-2 focus:ring-[#2596BE]/10 outline-none text-[#0D3543] placeholder:text-gray-300"
            required>
        </div>
      </div>

      <div>
        <label class="block text-[#0D3543] mb-2 text-sm font-medium">{{ 'auth.common.confirmPassword' | translate
          }}</label>
        <div class="relative flex items-center">
          <sham-i-lock-password-Bulk class="absolute start-3 text-[#6C737F] *:size-5" />
          <input type="password" [(ngModel)]="confirmPassword" name="confirmPassword" placeholder="****"
            class="w-full ps-10 pe-4 py-3 border border-[#BBDEEB] rounded-lg focus:ring-2 focus:ring-[#2596BE]/10 outline-none text-[#0D3543] placeholder:text-gray-300"
            required>
        </div>
      </div>

      <button type="submit" [disabled]="isLoading"
        class="w-full bg-[#2596BE] hover:bg-[#1a7a9c] text-white font-medium py-3 rounded-lg transition-all shadow-md shadow-sky-50 flex justify-center items-center">
        @if (isLoading) {
        <span class="loading loading-spinner loading-sm"></span>
        } @else {
        {{ 'auth.resetPassword.verifyAndProceed' | translate }}
        }
      </button>
    </form>

    <p class="text-xs text-gray-500">
      {{ 'auth.common.returnTo' | translate }} <a routerLink="/auth/login"
        class="text-[#2187AB] font-medium hover:underline"> {{ 'auth.common.login' | translate }}</a>
    </p>

  </div>
</div>
